const sectionCardVideoCss = `
[data-type='section-card-video'] [data-attribute='card-container'] {
  padding: 40px 0;
}

[data-type='section-card-video'] .container-page[data-show-style='true'] {
  padding: 32px;
  border-radius: 20px;
  margin: auto;
  max-width: calc(100% - 32px);
  width: max-content;
}

[data-type='section-card-video'] .wrap-card {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
}

[data-type='section-card-video'] .wrap-card .card-left[data-style-center-y='true'] {
  justify-content: center;
}

[data-type='section-card-video'] .wrap-card .card-left {
  width: calc((100% - 32px) / 2);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

[data-type='section-card-video'] .wrap-card .card-left .wrap-rated {
  display: flex;
  gap: 8px;
}

[data-type='section-card-video'] .wrap-card .card-left .wrap-rated .wrap-stars {
  display: flex;
  gap: 4px;
  color: #c4c4c4;
}

[data-type='section-card-video'] .wrap-card .card-left .wrap-rated .wrap-stars svg {
  fill: #c4c4c4;
}

[data-type='section-card-video'] .wrap-card .card-left .wrap-rated .wrap-stars[data-value='1'] svg:nth-child(-n + 1),
[data-type='section-card-video'] .wrap-card .card-left .wrap-rated .wrap-stars[data-value='2'] svg:nth-child(-n + 2),
[data-type='section-card-video'] .wrap-card .card-left .wrap-rated .wrap-stars[data-value='3'] svg:nth-child(-n + 3),
[data-type='section-card-video'] .wrap-card .card-left .wrap-rated .wrap-stars[data-value='4'] svg:nth-child(-n + 4),
[data-type='section-card-video'] .wrap-card .card-left .wrap-rated .wrap-stars[data-value='5'] svg:nth-child(-n + 5) {
  color: #f0b100;
  fill: #f0b100;
}

[data-type='section-card-video'] .wrap-card .card-left .card-content {
  margin-bottom: 20px !important;
}

[data-type='section-card-video'] .wrap-card .card-left .card-content h1,
[data-type='section-card-video'] .wrap-card .card-left .card-content h2,
[data-type='section-card-video'] .wrap-card .card-left .card-content h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 9px 0 !important;
}

[data-type='section-card-video'] .wrap-card .card-left .card-content [data-attribute='card-description'] {
  font-size: 16px;
}

[data-type='section-card-video'] .wrap-card .card-left .card-content .card-survay {
  margin-bottom: 16px;
}

[data-type='section-card-video'] .wrap-card .card-left .card-content .wrap-survay-item {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #000;
}

[data-type='section-card-video'] .wrap-card .card-left .card-content .wrap-survay-item .left-item {
  width: 80px;
  position: relative;
}

[data-type='section-card-video'] .wrap-card .card-left .card-content .wrap-survay-item .left-item svg {
  width: 100%;
  display: block;
}

[data-type='section-card-video'] .wrap-card .card-left .card-content .wrap-survay-item .left-item .wrap-percent {
  position: absolute;
  color: black;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  line-height: 20px;
  white-space: nowrap;
}

[data-type='section-card-video'] .wrap-card .card-left .card-content .wrap-survay-item .right-item {
  flex: 1;
  font-size: 16px;
}

[data-type='section-card-video'] .wrap-card .card-left .card-content p {
  margin-bottom: 0;
}

[data-type='section-card-video'] .wrap-card .card-left .row-btn .card-btn {
  display: flex;
  width: max-content;
  text-decoration: none;
  background-color: #2d3436;
  color: #fff;
  padding: 10px 40px;
  font-size: 14px;
  font-weight: bold !important;
  line-height: 20px;
}

[data-type='section-card-video'] .wrap-card .card-left .row-btn .sub-btn {
  font-size: 14px;
  color: #070707;
  line-height: 20px;
  margin-top: 8px;
}

[data-type='section-card-video'] .wrap-card .card-right {
  width: calc((100% - 32px) / 2);
}

[data-type='section-card-video'] .wrap-card .card-right .wrap-img {
  overflow: hidden;
}

[data-type='section-card-video'] .wrap-card .card-right .wrap-img img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-card-video'] .wrap-card .card-right .wrap-img video {
  width: 100%;
  height: 100%;
  display: block;
}

@container (max-width: 768px) {
  [data-type='section-card-video'] [data-attribute='card-container'] {
    padding: 16px 0;
  }

  [data-type='section-card-video'] .container-page[data-show-style='true'] {
    padding: 0;
  }

  [data-type='section-card-video'] .wrap-card .card-left[data-style-center-y='true'] [data-attribute='card-title'] {
    text-align: center;
  }

  [data-type='section-card-video'] .wrap-card .card-left {
    width: 100%;
    order: 2 !important;
  }

  [data-type='section-card-video'] .wrap-card .card-left .card-content h1,
  [data-type='section-card-video'] .wrap-card .card-left .card-content h2,
  [data-type='section-card-video'] .wrap-card .card-left .card-content h3 {
    font-size: 16px;
    line-height: 24px;
  }

  [data-type='section-card-video'] .wrap-card .card-left .card-content [data-attribute='card-description'] {
    font-size: 14px;
  }

  [data-type='section-card-video'] .wrap-card .card-left .card-content .wrap-survay-item .left-item .wrap-percent {
    font-size: 14px;
  }

  [data-type='section-card-video'] .wrap-card .card-left .card-content .wrap-survay-item .right-item {
    font-size: 14px;
  }

  [data-type='section-card-video'] .wrap-card .card-right {
    width: 100%;
    order: 1 !important;
  }
}
`;

export default sectionCardVideoCss;
